import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  ArrowUpRight, Gavel, Wrench, LandPlot, ListChecks, Archive, BarChart3, Users,
  ShieldCheck, MapPinned, HardHat, ShoppingCart, Building2, Bot, Bell,
} from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { MODULES } from "@/data/content";

const ICONS = {
  gavel: Gavel,
  wrench: Wrench,
  shield: ShieldCheck,
  land: LandPlot,
  map: MapPinned,
  hardhat: HardHat,
  shopping: ShoppingCart,
  building: Building2,
  tasks: ListChecks,
  archive: Archive,
  chart: BarChart3,
  robot: Bot,
  users: Users,
  bell: Bell,
};

export const Approach = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="moduller" className="relative bg-ink py-28 md:py-40 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="lg:col-span-8">
            <Reveal>
              <p className="text-xs font-semibold tracking-[0.3em] uppercase text-gold mb-8">Kurumsal İş Yönetimi</p>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-sand max-w-2xl">
                İş süreçlerini tek platformda topladım.
              </h2>
            </Reveal>
            <Reveal delay={2}>
              <p className="mt-6 text-base md:text-lg font-light text-mist max-w-2xl">
                Geliştirdiğim Kurumsal İş Yönetimi Platformu; ihale, hakediş, bakım, kamulaştırma ve
                arşiv süreçlerini izlenebilir tek bir sistemde buluşturur.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="border-t border-hairline">
          {MODULES.map((s, i) => {
            const Icon = ICONS[s.icon] || ListChecks;
            return (
              <Reveal
                key={s.no}
                delay={i}
                data-testid={`service-item-${s.no}`}
                onMouseEnter={() => setActive(i)}
                onMouseLeave={() => setActive(null)}
                className="group relative border-b border-hairline"
              >
                <div className="grid grid-cols-12 items-center gap-4 py-8 md:py-10">
                  <span className="col-span-2 md:col-span-1 font-semibold text-lg md:text-xl text-mist group-hover:text-gold transition-colors duration-300">
                    {s.no}
                  </span>
                  <h3 className="col-span-10 md:col-span-5 flex items-center gap-4 font-semibold tracking-tight text-2xl md:text-3xl text-sand transition-transform duration-500 group-hover:translate-x-2">
                    <Icon size={24} className="shrink-0 text-gold/70 group-hover:text-gold transition-colors" />
                    {s.title}
                  </h3>
                  <p className="hidden md:block col-span-5 text-sm md:text-base font-light text-mist max-w-md">
                    {s.desc}
                  </p>
                  <span className="hidden md:flex md:col-span-1 justify-end text-mist group-hover:text-gold transition-colors duration-300">
                    <ArrowUpRight size={22} className="transition-transform duration-500 group-hover:rotate-45" />
                  </span>
                </div>
                <p className="md:hidden pb-8 text-sm font-light text-mist max-w-md">{s.desc}</p>

                <AnimatePresence>
                  {active === i && (
                    <motion.div
                      layoutId="approach-glow"
                      className="pointer-events-none absolute inset-0 -z-0"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.4 }}
                      style={{ background: "linear-gradient(90deg, rgba(224,169,46,0.08), transparent 60%)" }}
                    />
                  )}
                </AnimatePresence>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
